import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Container, Box, Icon } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import Navigation from '../public/NavbarHomepage'
import ContactForm from '../public/ContactForm'
import { withTranslation } from 'react-i18next'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { FaBars, FaAngleDown } from "react-icons/fa";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const useStyles = makeStyles((theme) => ({
root: {
    position: 'absolute',
    backgroundColor: "transparent",
    color: "rgb(218, 218, 218)",
    fontSize: "14px",
    top: "12%",
    left: "7%"
},
containerNavbar: {
    [theme.breakpoints.down("sm")]: {
        background: '#191919', 
        padding: '0 25px'
    },
    [theme.breakpoints.up("sm")]: {
        position: 'relative',
        background: '#191919', 
        padding: '0 64px'
    },
  },
sidebarNavLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "5px"
},
wrapperContentLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "20px"
},
wrapperNavLegalitas: {
    padding: "5px",
    '&:hover': {
        background: "#e7e7e7"
    },
},
navLegalitas: {
    fontSize: '14px',
    color: 'black',
    '&:hover': {
        color: "#000"
    },
},
contentLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "20px",
    maxHeight: '500px',
    overflowY: 'scroll',
    whiteSpace: "break-spaces",
}
}));
const options = [
    'Select Langueage',
    'id',
    'en',
  ];
const TermsCondition = ({ t, i18n }) => {
    const classes = useStyles();
    const [ input, setInput ] = useState({
      email: '',
      password: ''
    })
    const history = useHistory()
    const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(1);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
    const handleMenuItemClick = (event, index) => {
        i18n.changeLanguage(options[index])
        setSelectedIndex(index);
        setAnchorEl(null);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };


    const [lang, setLang] = useState('')

    const setLocale = (locale) => {
      setLang(locale)
    }

    const gotoTermsPage = (e) => {
      history.push('/termscondition') 
      };

    const gotoPolicyPage = (e) => {
      history.push('/privacypolicy') 
    };

    return (
      <>
        <Container maxWidth="xl" className={classes.containerNavbar} style={{}}>
          <Navigation locale={setLocale}/>
        </Container>
        <Container className="signUpPage py-5 mb-5" component="main" maxWidth="lg">
            <h1 className='font-size-28 bold'>{t('policy.legality')}</h1>
            <Grid container>
                <Grid item xs={12} md={2}>
                    <Box className={classes.sidebarNavLegalitas} sx={{ mr: "1rem"}}>
                        <div className={classes.wrapperNavLegalitas} style={{background: "#e7e7e7"}}>
                            <a className={classes.navLegalitas} onClick={gotoTermsPage}>
                                <AssignmentIcon /> {t('policy.sideBarTerms')}
                            </a>
                        </div>
                        <div className={classes.wrapperNavLegalitas}>
                            <a className={classes.navLegalitas} onClick={gotoPolicyPage}>
                                <AssignmentTurnedInIcon /> {t('policy.sideBarPolicy')}
                            </a>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} md={10}>
                    <Box className={classes.wrapperContentLegalitas} sx={{ mr: "1rem"}}>
                        <h1 className='font-size-22'>{t('policy.titleTnC')}</h1>
                        <Box className={classes.contentLegalitas} sx={{ mr: "1rem"}}>
                            <p className='font-size-14 text-darkgrey'>
                            {/* <b>{t('terms.welcomeTerms')}</b> */}
                            {/* <br/><br/> */}
                            {t('terms.termsP1')}

                            <ol>
                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP1')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP11')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP12')}
                                  </li>
                                </ol>
                                <br/>
                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP2')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP21')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP22')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP23')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP24')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP25')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP26')}
                                  </li>
                                </ol>
                                <br/>

                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP3')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP31')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP32')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP33')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP34')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP35')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP36')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP37')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP38')}
                                  <a href='mailto:kiky@getquickey.com' style={{color: 'blue'}}>kiky@getquickey.com</a>
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP39')}
                                  </li>
                                </ol>
                                <br/>

                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP4')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP41')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP42')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP43')}
                                  </li>
                                </ol>
                                <br/>

                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP5')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP51')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP52')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP53')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP54')}
                                  </li>
                                </ol>
                                <br/>

                                <li className='bold text-darkgrey mb-5'>
                                  {t('terms.termsPoinP6')}
                                </li>
                                <ol>
                                  <li>
                                  {t('terms.termsPoinP61')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP62')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP63')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP64')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP65')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP66')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP67')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP68')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP68')}
                                  </li>
                                  <li>
                                  {t('terms.termsPoinP610')}
                                  </li>
                                </ol>
                                <br/>
                            </ol>
                            </p>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
        <div>
          <ContactForm/>
        </div>
      </>
    )
}

export default withTranslation()(TermsCondition)
